import activitylogApi from 'api/activitylog';
import { call, put, takeLatest } from 'redux-saga/effects';
import { activitylogAction, GetLogsPayload } from './activitylogSlice';
import { PayloadAction } from '@reduxjs/toolkit';

// ── Fetch Modules ─────────────────────────────────────────────────────────────
function* fetchModules() {
  try {
    const response: any = yield call(activitylogApi.getModules);
    const data = response.data;
    if (data.success) {
      yield put(activitylogAction.getModulesSuccess(data));
    } else {
      yield put(activitylogAction.getModulesFailed({ message: data.message }));
    }
  } catch (error: any) {
    yield put(
      activitylogAction.getModulesFailed({
        message: error?.response?.data?.message || 'Failed to fetch modules',
      })
    );
  }
}

// ── Fetch Logs ────────────────────────────────────────────────────────────────
function* fetchActivityLogs(action: PayloadAction<GetLogsPayload>) {
  try {
    const response: any = yield call(activitylogApi.getLogs, action.payload);
    const data = response.data;
    if (data.success) {
      yield put(activitylogAction.getActivityLogsSuccess(data));
    } else {
      yield put(activitylogAction.getActivityLogsFailed(data));
    }
  } catch (error: any) {
    yield put(
      activitylogAction.getActivityLogsFailed(
        error?.response?.data || { message: 'Failed to fetch logs' }
      )
    );
  }
}

export default function* activitylogSaga() {
  yield takeLatest(activitylogAction.getModules.type, fetchModules);
  yield takeLatest(activitylogAction.getActivityLogs.type, fetchActivityLogs);
}
